import type { IntegrationFn } from '@sentry/core'

import { getHeartbeatInfo } from '../../webrtc/blocs/heartbeat'

const heartbeatIntegration: IntegrationFn = () => ({
  name: 'HeartbeatIntegration',
  processEvent: async (event) => {
    // using recommended approach @see https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/custom/#processevent
    // eslint-disable-next-line no-param-reassign
    event.extra = {
      ...event.extra,
      heartbeat: await getHeartbeatInfo(),
    }
    return event
  },
})

export { heartbeatIntegration }
